import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-navtop',
  templateUrl: './navtop.component.html',
  styleUrls: ['./navtop.component.sass']
})
export class NavtopComponent implements OnInit {
  uid;
  peopleDoc;
  profilePicture: string = "./assets/img/no-people.png";

  constructor(
    private route: Router,
    public auth: AuthenticationService,
    private db: FirestoreService
  ) {}

  ngOnInit(): void {
    this.auth.getPeopleSignInUid()
    .then(data =>{
      this.uid = data.uid;      
    })   
    .then( res=>{
      this.peopleDoc = this.db.getMainDoc('people', this.uid)
    })
    
    

  }

  //route
  routePeopleDetailPage(){
    this.route.navigateByUrl('people/'+this.uid);
  }
  routeBusinessListPage(){
    this.route.navigateByUrl('/popular/businesses');
  }
  routeGovernmentListPage(){
    this.route.navigateByUrl('/government/categories');
  }
  routeTourPackageListPage(){
    this.route.navigateByUrl('/tourpackages');
  }
  routeHandicraftListPage(){
    this.route.navigateByUrl('/handicrafts');
  }
  routePaintingListPage(){
    this.route.navigateByUrl('/paintings');
  }

}
